

























import { Vue, Component, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import Tips from "@/components/common/index/Tips.vue";

import { Tip } from "@/common/interface";


@Component({
  components: {
    tips: Tips
  }
})
export default class VirtualGroupModal extends Vue {
  @Prop()
  show!: boolean;
  @Prop()
  content!: boolean;
  @Prop()
  virtualGroupTips!: Tip;
  @Getter("mainTextColor")
  mainTextColor!: any;


  handlePreview() {
    this.handleCloseModal();
    Vue.$confirm({
      oneBtn: true,
      title: this.virtualGroupTips.title,
      text: this.virtualGroupTips.content,
      classname: 'text-align-left'
    });
  }
  handleCloseModal() {
    this.$emit("hide");
  }
}
